import { Card, CardContent, CardContentProps } from '@mui/material';
import { ReactNode } from 'react';

const CardWrapper = ({ children, ...props }: { children: ReactNode } & CardContentProps) => (
  <Card>
    <CardContent sx={{ p: 3 }} {...props}>
      {children}
    </CardContent>
  </Card>
);

export default CardWrapper;
